import { render, staticRenderFns } from "./NewBatchTransferDetails.template.vue?vue&type=template&id=6842d190&scoped=true&"
var script = {}
import style0 from "./NewBatchTransferDetails.template.vue?vue&type=style&index=0&id=6842d190&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6842d190",
  null
  
)

export default component.exports